import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { Icon } from '../../Defaults/Defaults';
import { FlexRowCenter, FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { SvgIcon, IconType } from './SvgIcon';

interface Props {
  id?: string;
  onClick?: (e: any) => void;
  selected: boolean;
  label?: string;
  theme: any;
  name?: string;
  rounded?: boolean;
  wrapperStyle?: any;
}

function CheckBox({
  id,
  name = '',
  onClick,
  selected,
  label,
  theme,
  rounded,
  wrapperStyle = {},
}: Props) {
  const handleClick = e => {
    if (onClick) {
      onClick({
        ...e,
        target: {
          value: !selected,
          name,
        },
      });
    }
  };

  return (
    <Wrapper style={wrapperStyle}>
      {rounded ? (
        <Rounded active={selected} onClick={handleClick}>
          <Dot selected={selected} />
        </Rounded>
      ) : (
        <StyledBox onClick={handleClick} id={id} selected={selected}>
          <CheckIcon selected={selected}>
            <SvgIcon
              icon={IconType.checked}
              alt="Checkbox vybraný"
              width={22}
              height={16}
              viewBox="0 0 11 8"
              fill={theme.colors.black}
            />
          </CheckIcon>
        </StyledBox>
      )}
      {label && <Label onClick={handleClick}>{label}</Label>}
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  align-items: center;
  margin-right: ${rem(30)};

  ${({ theme }) => theme.mediab.l925`
    margin: 0;
    margin-bottom: ${rem(30)};

    &:last-child {
      margin-bottom: 0;
    }
  `}
`;

const CheckIcon: any = styled(FlexRowCenter)`
  width: ${rem(11)};
  height: ${rem(16)};
  display: ${(props: any) => (props.selected ? 'flex' : 'none')};
  pointer-events: none;
`;

const StyledBox: any = styled(FlexRowCenter)`
  border: ${({ theme }) => theme.borders.secondary};
  border-radius: ${rem(4)};
  box-shadow: ${({ theme }) => theme.boxShadow.input};

  width: ${rem(24)};
  height: ${rem(24)};
  margin-right: ${rem(12)};
  background: transparent;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

const Label = styled.span`
  color: black;
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  font-weight: 400;
  cursor: pointer;
`;

const Rounded = styled(FlexRowCenter)<{ active: boolean }>`
  cursor: pointer;
  width: ${rem(24)};
  height: ${rem(24)};
  border-radius: 50%;
  border: ${({ theme, active }) =>
    `${active ? rem(2) : rem(1)} solid ${
      active ? theme.colors.primary : theme.colors.borderColor
    }`};
  box-shadow: ${({ theme }) => theme.boxShadow.input};
  box-shadow: ${({ theme }) => theme.boxShadow.input};
  margin-right: ${rem(16)};
`;

const Dot = styled.div<{ selected?: boolean }>`
  display: ${({ selected }) => (selected ? 'flex' : 'none')};
  width: ${rem(12)};
  height: ${rem(12)};
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
`;

const WithThemeCheckBox: any = withTheme(CheckBox);
export { WithThemeCheckBox as CheckBox };
